export default function Aboutbox(props) {
  return (
    <div className='col-md-4 col-xs-12'>
      <div className="box-wrapper about" style={{marginTop: props.boxPosition}}>
        <h3>{props.title}</h3>
        <p>{props.text}</p>
      </div>
    </div>
  );
}
